import { render, staticRenderFns } from "./FigureDetails.vue?vue&type=template&id=89765324&scoped=true&"
import script from "./FigureDetails.vue?vue&type=script&lang=js&"
export * from "./FigureDetails.vue?vue&type=script&lang=js&"
import style0 from "./FigureDetails.vue?vue&type=style&index=0&id=89765324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89765324",
  null
  
)

export default component.exports